function debounce(fn, wait = 300) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

if (!customElements.get('announcement-bar')) {
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('.announcement__slider');
      this.localization = this.querySelector('.announcement__localization');
      this.links = this.querySelectorAll('.js-announcement-link');
      this.menu = document.querySelector('.main-menu__content');
      this.isPaused = false;
      this.bindEvents();
      this.init();
    }

    disconnectedCallback() {
      if (this.moveLinksHandler)
        window.removeEventListener('on:breakpoint-change', this.moveLinksHandler);
      if (this.moveLocalizationHandler)
        window.removeEventListener('on:breakpoint-change', this.moveLocalizationHandler);
    }

    bindEvents() {
      if (this.links) {
        this.moveLinksHandler = this.moveLinksHandler || this.moveLinks.bind(this);
        window.addEventListener('on:breakpoint-change', this.moveLinksHandler);
      }
      if (this.localization) {
        this.moveLocalizationHandler = this.moveLocalizationHandler
          || debounce(this.moveLocalization.bind(this));
        window.addEventListener('on:breakpoint-change', this.moveLocalizationHandler);
      }
      if (this.slider) {
        this.slider.addEventListener('mouseenter', this.pauseSlider.bind(this));
        this.slider.addEventListener('mouseleave', this.resumeSlider.bind(this));
      }
    }

    init() {
      if (this.slider) {
        const slides = Array.from(this.slider.querySelectorAll('.announcement__text'));
        if (slides.length === 0) return;

        /* ── Slider-Container vorbereiten ── */
        this.slider.style.cssText = `
          position: relative !important;
          overflow: hidden !important;
          scroll-snap-type: none !important;
        `;

        /* Höhe des Sliders = Höhe der ersten Slide */
        const setHeight = () => {
          this.slider.style.height = slides[0].scrollHeight + 'px';
        };

        /* ── Alle Slides absolut stapeln ── */
        slides.forEach((slide, i) => {
          slide.style.cssText = `
            position: absolute !important;
            top: 0 !important;
            left: 0 !important;
            width: 100% !important;
            opacity: ${i === 0 ? '1' : '0'} !important;
            transition: opacity 0.7s ease !important;
            pointer-events: ${i === 0 ? 'auto' : 'none'} !important;
          `;
          if (i === 0) slide.classList.add('is-visible');
        });

        setHeight();
        window.addEventListener('resize', setHeight);

        /* ── Fade-Rotation ── */
        const nextSlide = () => {
          if (!this.isPaused && theme.elementUtil.isInViewport(this)) {
            const curr = this.slider.querySelector('.announcement__text.is-visible');
            const currIndex = slides.indexOf(curr);
            const nextIndex = (currIndex + 1) % slides.length;

            curr.style.opacity = '0';
            curr.style.pointerEvents = 'none';
            curr.classList.remove('is-visible');

            slides[nextIndex].style.opacity = '1';
            slides[nextIndex].style.pointerEvents = 'auto';
            slides[nextIndex].classList.add('is-visible');
          }
          setTimeout(nextSlide, this.dataset.slideDelay || 5000);
        };

        setTimeout(nextSlide, this.dataset.slideDelay || 5000);
      }

      if (this.links) this.moveLinks();
      if (this.localization) this.moveLocalization();
    }

    moveLinks() {
      const menuAnnouncementLinks = document.querySelector('.mob__announcement-links');
      if (!theme.mediaMatches.md && !menuAnnouncementLinks) {
        const mobNav = document.createElement('nav');
        mobNav.classList.add('mob__announcement-links', 'secondary-nav');
        this.links.forEach((link) => {
          mobNav.innerHTML += `<li><a class="secondary-nav__item" href="${link.href}">${link.innerText}</a></li>`;
        });
        this.menu.appendChild(mobNav);
      } else if (theme.mediaMatches.md && menuAnnouncementLinks) {
        menuAnnouncementLinks.remove();
      }
    }

    moveLocalization() {
      this.slider = this.querySelector('.announcement__slider');
      this.localization = this.querySelector('.announcement__localization');
      this.links = this.querySelectorAll('.js-announcement-link');
      this.menu = document.querySelector('.main-menu__content');
      const menuLocalization = document.querySelector('.mob__localization');
      if (!theme.mediaMatches.md && !menuLocalization) {
        const mobLocalizationElem = document.createElement('div');
        mobLocalizationElem.classList.add('mob__localization');
        mobLocalizationElem.appendChild(this.localization.firstElementChild);
        this.menu.appendChild(mobLocalizationElem);
      } else if (theme.mediaMatches.md && menuLocalization) {
        this.localization.appendChild(menuLocalization.firstElementChild);
        menuLocalization.remove();
      }
    }

    pauseSlider() { this.isPaused = true; }
    resumeSlider() { this.isPaused = false; }
  }

  customElements.define('announcement-bar', AnnouncementBar);
}